module.exports = __webpack_public_path__ + "static/img/NSW-9.d4ce6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-9.jpg
// module id = /BOa
// module chunks = 0